import { FC } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { ABOUT_PRODUCTS } from '~/src/params';
import { IMAGE_QUALITY } from '~/src/models/constants/image-quality.constants';
import { onSendProductClickAnalytics } from './product-group.analytics';
import DefaultProductImage from '~/src/images/agency-products/default-product-image.png';
import DefaultLogoProductImage from '~/src/images/agency-products/default-logo-product-image.png';
import type { ProductGroupInterface } from '~/src/models/types/knowledge-base.types';
import * as Styled from './product-group.styles';

export const ProductGroup: FC<ProductGroupInterface> = ({ name, bigImage, smallImage, products, tag }) => {
    const router = useRouter();
    const hasProducts = products.length;
    const hasOneProduct = products.length === 1;
    const hasManyProducts = products.length > 1;

    const handleClick = (sefUrl: string, name: string) => {
        onSendProductClickAnalytics(name, sefUrl, true);
        router.push({ pathname: `${ABOUT_PRODUCTS}/${sefUrl}` }).then();
    };

    return (
        <>
            {!!hasProducts && (
                <Styled.ProductGroupContainer
                    hasManyProducts={hasManyProducts}
                    hasOneProduct={hasOneProduct}
                    onClick={() => hasOneProduct && handleClick(products[0]?.sefUrl, products[0]?.name)}
                >
                    {hasOneProduct && (
                        <Styled.LogoImage
                            width={352}
                            height={160}
                            alt={'product'}
                            src={bigImage || DefaultProductImage}
                            unoptimized={!!bigImage}
                            quality={IMAGE_QUALITY.HIGH}
                        />
                    )}
                    {!!tag && <Styled.Tag>{tag}</Styled.Tag>}
                    <Styled.ProductGroupHeader hasOneProduct={hasOneProduct}>
                        {hasManyProducts && (
                            <Styled.SmallLogoContainer>
                                <Image
                                    width={20}
                                    height={20}
                                    alt={'product'}
                                    src={smallImage || DefaultLogoProductImage}
                                    unoptimized
                                />
                            </Styled.SmallLogoContainer>
                        )}
                        <Styled.ProductGroupName>{name}</Styled.ProductGroupName>
                    </Styled.ProductGroupHeader>
                    {hasManyProducts && (
                        <Styled.ProductList>
                            {products.map((value) => (
                                <Styled.Product
                                    key={value.order}
                                    href={`${ABOUT_PRODUCTS}/${value.sefUrl}`}
                                    onClick={() => onSendProductClickAnalytics(value.name, value.sefUrl, false)}
                                >
                                    {value?.name}
                                </Styled.Product>
                            ))}
                        </Styled.ProductList>
                    )}
                </Styled.ProductGroupContainer>
            )}
        </>
    );
};
